export default __webpack_public_path__ + "static/media/voucher.b95cec45.svg";